export default __webpack_public_path__ + "static/media/property_682.7827cd32.png";